const LayoutContainer = ({ children }: { children: React.ReactNode }) => {
  return <div className='flex min-h-full min-w-full grow flex-col items-center'>{children}</div>;
};
export default LayoutContainer;
